import { type ModalProps } from "./modal";
import { KeyValueObject } from "../types/general";

export function getContentWidth(width: ModalProps["width"]): KeyValueObject {
    if (width === "xs") return { maxWidth: "400px" };
    if (width === "sm") return { maxWidth: "500px" };
    if (width === "lg") return { maxWidth: "800px" };
    if (width === "xl") return { maxWidth: "1000px" };
    if (width === "2xl") return { maxWidth: "1400px" };
    if (width === "full") return { maxWidth: "none" };
    if (width) {
        return { maxWidth: width };
    }
    return { maxWidth: "600px" };
}

export function getContentHeight(height: ModalProps["height"]): KeyValueObject {
    if (height === "full") {
        return { height: "100%" };
    }
    if (height === "sm") {
        return { height: "50%" };
    }
    if (height === "lg") {
        return { height: "75%" };
    }
    if (height === "auto") {
        return { maxHeight: "100%" };
    }
    return { maxHeight: "100%" };
}

export function getPageHeight(height: ModalProps["height"]): KeyValueObject {
    if (height === "auto") {
        return { maxHeight: "100%" };
    }
    if (height === "full" || height === "sm" || height === "lg") {
        return { height: "100%" };
    }
    return { maxHeight: "100%" };
}

export function getBodyHeight(height: ModalProps["height"]): KeyValueObject | null {
    if (height === "auto" || height === "full" || height === "sm" || height === "lg") {
        return { height: "100%" };
    }
    return null;
}

export function getBorderRadius(rounded: ModalProps["rounded"], theme: any): KeyValueObject | null {
    if (rounded === "md") {
        return { borderRadius: theme.borderRadius.DEFAULT };
    }
    if (rounded === "lg") {
        return { borderRadius: theme.borderRadius.lg };
    }
    if (rounded === "xl") {
        return { borderRadius: theme.borderRadius.xl };
    }
    return null;
}

export function getPosition(open: ModalProps["open"], lockScreen: ModalProps["lockScreen"]): KeyValueObject {
    if (!lockScreen) {
        return { position: "fixed" };
    }
    if (open) {
        return { position: "absolute" };
    }
    return { position: "fixed" };
}
